// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1EHbM","title":"Images90_title__3tNiG","images":"Images90_images__2wMPR"};